import React from "react";
import { Outlet, Navigate, useNavigate } from "react-router-dom";
import FadeOutlet from "@/components/FadeOutlet";
import { Shield, ExternalLink, LogOut } from "lucide-react";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/FindoSpinner";

// Dedicated chrome for the superadmin console. Intentionally shares NOTHING
// with the B2B partner dashboard (no org profile, quota, partner nav, etc.).
export default function SuperadminLayout() {
  const { partner, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <PageLoader label="Chargement…" className="min-h-screen" />;
  }
  if (!partner) return <Navigate to="/superadmin/login" replace />;

  const isSuperadmin =
    !!partner.is_superadmin || (partner.email || "").toLowerCase() === "admin@findo.app";
  if (!isSuperadmin) return <Navigate to="/b2b/registry" replace />;

  return (
    <div className="min-h-screen internal-ui" data-testid="superadmin-layout">
      <header className="sticky top-0 z-40 bg-findo-navy text-white border-b border-white/10">
        <div className="h-16 px-4 md:px-8 flex items-center justify-between max-w-[1600px] mx-auto">
          <div className="flex items-center gap-3">
            <Logo size={30} withText textClass="text-lg text-white" />
            <span className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs font-bold tracking-wide">
              <Shield size={14} /> Console Superadmin
            </span>
          </div>

          <div className="flex items-center gap-2 md:gap-3">
            <span className="hidden md:block text-sm text-white/70 truncate max-w-[200px]" data-testid="superadmin-identity">
              {partner.email}
            </span>
            <ThemeToggle />
            <a
              href="/"
              className="inline-flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-semibold text-white/90 hover:bg-white/10 transition-colors"
              data-testid="superadmin-view-site"
            >
              <ExternalLink size={16} /> <span className="hidden md:inline">Voir le site</span>
            </a>
            <button
              onClick={() => { logout(); navigate("/"); }}
              className="inline-flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-semibold bg-white/10 hover:bg-red-500 transition-colors"
              data-testid="superadmin-logout"
            >
              <LogOut size={16} /> <span className="hidden md:inline">Déconnexion</span>
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-[1600px] mx-auto">
        <FadeOutlet />
      </main>
    </div>
  );
}
